import React from "react";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { languages } from "../i18n";
import { Globe } from "lucide-react";

const LanguageSelector = ({ className = "" }) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (value) => {
    i18n.changeLanguage(value);
    // Set RTL direction for Arabic
    document.documentElement.dir = value === 'ar' ? 'rtl' : 'ltr';
  };

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  return (
    <Select value={i18n.language} onValueChange={handleLanguageChange}>
      <SelectTrigger className={`w-[140px] ${className}`} data-testid="language-selector">
        <Globe className="w-4 h-4 mr-2" />
        <SelectValue>
          {currentLang.flag} {currentLang.name}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
